import { useContext, type FunctionComponent } from 'react';
import { SurveyPageContext } from '../context/SurveyPageContext';
import * as styles from './ProgressBar.module.css';

const ProgressBar: FunctionComponent = () => {
  const { paginatedSurvey, surveyPage } = useContext(SurveyPageContext);
  const pagesString = `${surveyPage} of ${paginatedSurvey.size}`;
  const width = (surveyPage / paginatedSurvey.size) * 100;

  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.barWrapper}>
        <div className={styles.progressBar} />
        <div className={styles.progressBarCompletion} style={{ width: `${width}%` }} />
      </div>
      <div className={styles.pages}>{pagesString}</div>
    </div>
  );
};

export default ProgressBar;
